import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const activeMarketSelector = (state) => resolveProp('market.activeMarket', state);

export default createSelector(activeMarketSelector, (activeMarket) => activeMarket);
